<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title>Voorraadmutatie</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-row>
        <div [ngStyle]="colorAf" (click)="doMut(-1)">
            -1: Afboeken
        </div>
        <div [ngStyle]="colorCheck" (click)="doMut(0)">
            Check
        </div>
        <div [ngStyle]="colorBij" (click)="doMut(1)">
            +1: Bijboeken
        </div>
    </ion-row>
    <ion-item>
        <input
            placeholder="Artikel nummer"
            class="inputField"
            onclick="this.select()"
            (input)='artChanged($any($event.target).value)'
            [(ngModel)]='inpArtnr'
            #inpArtnrElt
        >
    </ion-item>
    <ion-item>
        {{artdes}}<br>
        Voorraad: {{voorraad}}
    </ion-item>

</ion-content>
